import {
  actionLoading,
  actionSuccess,
  actionErrored,
  actionReset,
} from 'api/helpers';
import { unAuthRequest, authRequest } from 'api/helpers';
import URL from 'api/endpoints';

// View system metadata
export const FETCH_SYSTEM_METADATA = 'FETCH_SYSTEM_METADATA';

export const fetchSystemMetaDataLoading = actionLoading(FETCH_SYSTEM_METADATA);
export const fetchSystemMetaDataSuccess = actionSuccess(FETCH_SYSTEM_METADATA);
export const fetchSystemMetaDataErrored = actionErrored(FETCH_SYSTEM_METADATA);

export const fetchSystemMetaData = (collectionName) => {
  return (dispatch) =>
    authRequest.get(
      dispatch,
      URL.system_metadata,
      fetchSystemMetaDataLoading,
      fetchSystemMetaDataSuccess,
      fetchSystemMetaDataErrored
    );
};
